import "Layouts/default";
import "Ui/slider";
import tippy from "tippy.js";

import { updateLazy } from "Functions/lazy";

document.addEventListener("DOMContentLoaded", function () {
    updateLazy();

    $(".js-banner-tooltip-trigger").each(function () {
        const $trigger = $(this),
            $content = $trigger.next(".js-banner-tooltip");

        tippy($trigger[0], {
            content: $content[0],
            arrow: true,
            trigger: "click",
            interactive: true,
            theme: "light",
            duration: [600, 300],
            inertia: true,
            popperOptions: {
                modifiers: {
                    preventOverflow: {
                        enabled: true,
                        boundariesElement: $("#index-main")[0],
                    },
                },
            },
            onShow(instance) {
                $content.find(".js-banner-tooltip-close").on("click", function () {
                    instance.hide(); // Close the tooltip
                });
            },
        });

        $content.addClass("is-loaded");
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const modalWrapper = document.querySelector(".js-success-registration-modal");

    if (modalWrapper) {
        $("#success-registration-modal").modal("show");
    }
});